import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TicketsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor( private http: HttpClient ) { }

  public getTicketList(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/ticketMaintenance/tickets/all', options);
  }
  public getTicketCounter(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/ticketMaintenance/count', options);
  }
  public getTicketListByCenters(context, lang, udid, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { centerInternalIds };
    return this.http.get(this.BASE_URL + 'private/v2.0/ticketMaintenance/tickets/byCenters', options);
  }
  public getTicketInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/ticketMaintenance/ws_getTicketDetails', item, options);
  }
  public addNewTicket(context, lang, udid, active, ticketName, centerInternalIds, ticketTextFlag, ticketText, ticketHtmlFlag, ticketHtml) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { active, ticketName, centerInternalIds, ticketTextFlag, ticketText, ticketHtmlFlag, ticketHtml };
    return this.http.post(this.BASE_URL + 'private/v2.0/ticketMaintenance/ticket', item, options);
  }
  public updateTicketInfo(context, lang, udid, internalId, active, ticketName) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, ticketName };
    return this.http.patch(this.BASE_URL + 'private/v2.0/ticketMaintenance/ticket', item, options);
  }
  public updateTicketCenters(context, lang, udid, internalId, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, centerInternalIds };
    return this.http.patch(this.BASE_URL + 'private/v2.0/ticketMaintenance/ticket/center', item, options);
  }
  public updateTicketTemplates(context, lang, udid, internalId, active, centerInternalId, ticketHtmlFlag, ticketHtml, ticketTextFlag, ticketText) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, centerInternalId, ticketTextFlag, ticketText, ticketHtmlFlag, ticketHtml };
    return this.http.patch(this.BASE_URL + 'private/v2.0/ticketMaintenance/ticket', item, options);
  }
  public updateTicketStatus(context, lang, udid, internalId, active) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active };
    return this.http.patch(this.BASE_URL + 'private/v2.0/ticketMaintenance/ticket', item, options);
  }

  public deleteTicket(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/ticketMaintenance/ws_deleteTicket', item, options);
  }

  public getZplPreview(dpmm, width, height, index, raw) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('Accept', 'image/png');
    options['headers'] = options['headers'].append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    const item = { raw };
    return this.http.post(`http://api.labelary.com/v1/printers/${dpmm}/labels/${width}x${height}/${index}/^xa^cfa,50^fo100,100^fdHello World^fs^xz`, options);
  }
}
